// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProjectInterestedIn_wrapper__KRwRc"};